import { State } from '../../reducers/rootReducer'
import CarlineData from '../../../entities/CarlineData'

const carlineDataSelector = (state: State): CarlineData => state.carlineData

export default carlineDataSelector
